// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  :root {

      --muted: #9aa3ad;
      --accent: #f5a623;
      /* orange */
      --accent-dark: #e8950b;
      --shadow: 0 8px 18px rgba(20, 30, 40, 0.06);
      --soft-shadow: 0 4px 10px rgba(20, 30, 40, 0.06);
      --radius: 10px;
      --gap: 22px;
      --container-width: 100%;
      font-family: "Poppins", sans-serif;
      color: #222831;
  }

  /* Main column */

  

  /* Right column */
  .right {
      position: sticky;
      top: 28px;
      height: calc(100vh - 84px);
      display: flex;
      flex-direction: column;
      gap: 16px;
  }


 

  /* Responsive */
  @media (max-width:1150px) {
      .content {
          grid-template-columns: 200px 1fr;
      }

      .rightcol {
          display: none;
      }

      .hambutton {
          display: inline-flex;
      }
  }

  @media (max-width:720px) {
      .content {
          grid-template-columns: 1fr;
          padding: 12px;
      }

      .rightcol {
          grid-template-columns: 1fr;
      }
  }

.p-panelmenu .p-menuitem-icon {
  color: var(--primary-color); /* picks from PrimeReact theme */
  font-size: 1.25rem; /* text-lg */
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/common/style.css"],"names":[],"mappings":";EACE;;MAEI,gBAAgB;MAChB,iBAAiB;MACjB,WAAW;MACX,sBAAsB;MACtB,2CAA2C;MAC3C,gDAAgD;MAChD,cAAc;MACd,WAAW;MACX,uBAAuB;MACvB,kCAAkC;MAClC,cAAc;EAClB;;EAEA,gBAAgB;;;;EAIhB,iBAAiB;EACjB;MACI,gBAAgB;MAChB,SAAS;MACT,0BAA0B;MAC1B,aAAa;MACb,sBAAsB;MACtB,SAAS;EACb;;;;;EAKA,eAAe;EACf;MACI;UACI,gCAAgC;MACpC;;MAEA;UACI,aAAa;MACjB;;MAEA;UACI,oBAAoB;MACxB;EACJ;;EAEA;MACI;UACI,0BAA0B;UAC1B,aAAa;MACjB;;MAEA;UACI,0BAA0B;MAC9B;EACJ;;AAEF;EACE,2BAA2B,EAAE,gCAAgC;EAC7D,kBAAkB,EAAE,YAAY;AAClC","sourcesContent":["\n  :root {\n\n      --muted: #9aa3ad;\n      --accent: #f5a623;\n      /* orange */\n      --accent-dark: #e8950b;\n      --shadow: 0 8px 18px rgba(20, 30, 40, 0.06);\n      --soft-shadow: 0 4px 10px rgba(20, 30, 40, 0.06);\n      --radius: 10px;\n      --gap: 22px;\n      --container-width: 100%;\n      font-family: \"Poppins\", sans-serif;\n      color: #222831;\n  }\n\n  /* Main column */\n\n  \n\n  /* Right column */\n  .right {\n      position: sticky;\n      top: 28px;\n      height: calc(100vh - 84px);\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n  }\n\n\n \n\n  /* Responsive */\n  @media (max-width:1150px) {\n      .content {\n          grid-template-columns: 200px 1fr;\n      }\n\n      .rightcol {\n          display: none;\n      }\n\n      .hambutton {\n          display: inline-flex;\n      }\n  }\n\n  @media (max-width:720px) {\n      .content {\n          grid-template-columns: 1fr;\n          padding: 12px;\n      }\n\n      .rightcol {\n          grid-template-columns: 1fr;\n      }\n  }\n\n.p-panelmenu .p-menuitem-icon {\n  color: var(--primary-color); /* picks from PrimeReact theme */\n  font-size: 1.25rem; /* text-lg */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
